import React from 'react';
import {Redirect, Switch} from 'react-router-dom';
import PrivateRoute from '../../PrivateRoute';
import FlightScheduleEdit from 'components/flights/scheduling/FlightScheduleEdit';
import MainScheduling from './MainScheduling';
import moment from 'moment';
import ScheduledGroupsList from 'components/scheduling/ScheduledGroupsList';
import ScheduledFlightsList from 'components/scheduling/ScheduledFlightsList';
import SchedulingV2Routes from "routes/scheduling";
import {basePath} from 'routes/scheduling-path';

export {basePath} from 'routes/scheduling-path';

/** Handles all routes related to scheduling */
// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
    <Switch>
        <Redirect exact from={basePath('passenger')} to={basePath('groups')} />
        <PrivateRoute
            exact
            path={basePath('groups')}
            render={({ history }) => {
                return <ScheduledGroupsList
                    onGroupClicked={({ date, name, lkc }) => {
                        let flightDate = encodeURIComponent( moment(date).format('YYYY-MM-DD') );
                        let groupName = encodeURIComponent( name );
                        let lastKnownController = encodeURIComponent( lkc );

                        history.push(basePath(`schedule/${flightDate}/${groupName}/${lastKnownController}`));
                    }}
                />
            }}
        />
        {SchedulingV2Routes}
        <PrivateRoute
            exact
            path={basePath('flight')}
            render={({ history }) => {
                return <ScheduledFlightsList
                    onFlightClicked={(flight) => history.push(basePath(`flight/${flight._id}`))}
                    onNewFlightSubmitted={(flightId) => history.push(basePath(`flight/${flightId}`))}
                />
            }}
        />
        <PrivateRoute exact path={basePath('flight/:id')} component={FlightScheduleEdit} />
        <PrivateRoute component={MainScheduling} />
    </Switch>
)
